import { mapGetters } from 'vuex';

const Search = {
	name: 'Search',
	template: `
		<div>
			<button class="btn-search" @click="toggleSearch"><i class="fa fa-search"></i></button>
		</div>
	`,
	data: function() {
		return window.store.search;
	},
	methods: {
		toggleSearch: function() {


			if(!this.isOpened) {
				if(window.store.countrySelector.state.show) {
					window.store.countrySelector.hide();
				}
				if(window.store.megaMenu.state.show) {
					window.store.megaMenu.hide();
				}
			}

			this.$store.dispatch('search/toggleSearch');
			if(this.isOpened) {
				this.$store.dispatch('overlay/show', { show: true, cb: this.closeSearch });
			} else {
				this.$store.dispatch('overlay/hide');
			}
		},
		closeSearch: function() {
			if(this.isOpened) {
				this.$store.dispatch('search/toggleSearch');
			}
		},
	},
	computed: {
		...mapGetters({
			isOpened: 'search/isOpened',
		}),
	}
};

export default Search;



// WEBPACK FOOTER //
// ../shared/components/search/search.js